import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withKeys as _withKeys, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "layout-column gap-md" };
const _hoisted_2 = { class: "layout-row gap-md justify-between md:justify-end" };
import { OrButtonV3, OrInputV3, OrModalV3 } from '@onereach/ui-components';
import { ref } from 'vue';
import useI18n from '@/composables/useI18n';
export default /*#__PURE__*/ _defineComponent({
    __name: 'MFARecoveryModal',
    props: {
        isOpenRecovery2fa: { type: Boolean },
        recoveryError: {},
        isLoading: { type: Boolean },
        modelValue: {}
    },
    emits: ["submit", "toogleOpenRecovery2fa", "update:modelValue"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const { translate } = useI18n();
        const emptyError = ref('');
        const updateModelValue = (value) => {
            const trimmed = value === undefined ? value : value.trim();
            emit('update:modelValue', trimmed);
            emptyError.value = '';
            return trimmed;
        };
        const handleSubmit = () => {
            if (!props.modelValue || props.modelValue.trim() === '') {
                emptyError.value = translate('login.password_restore.This field is required');
            }
            else {
                emit('submit');
            }
        };
        const handleClose = () => {
            emptyError.value = '';
            emit('toogleOpenRecovery2fa', false);
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(OrModalV3), {
                size: "s",
                "is-open": _ctx.isOpenRecovery2fa,
                class: "recovery-modal",
                onClose: handleClose
            }, {
                header: _withCtx(() => [
                    _createElementVNode("div", null, _toDisplayString(_unref(translate)('login.login.accessRecovery')), 1)
                ]),
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("div", null, _toDisplayString(_unref(translate)('login.login.ifYouHaveProblems')), 1),
                        _createVNode(_unref(OrInputV3), {
                            "model-value": _ctx.modelValue,
                            label: _unref(translate)('login.login.recoveryCode'),
                            error: _ctx.recoveryError || emptyError.value,
                            "onUpdate:modelValue": updateModelValue,
                            onKeyup: _withKeys(handleSubmit, ["enter", "native"])
                        }, null, 8, ["model-value", "label", "error"]),
                        _createElementVNode("div", null, _toDisplayString(_unref(translate)('login.login.ifYouveLost')), 1)
                    ])
                ]),
                footer: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                        _createVNode(_unref(OrButtonV3), {
                            variant: "outlined",
                            class: "flex-1 md:!flex-none",
                            disabled: _ctx.isLoading,
                            onClick: handleClose
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(translate)('login.login.cancel')), 1)
                            ]),
                            _: 1
                        }, 8, ["disabled"]),
                        _createVNode(_unref(OrButtonV3), {
                            color: "primary",
                            class: "flex-1 md:!flex-none",
                            disabled: !!emptyError.value,
                            loading: _ctx.isLoading,
                            onClick: handleSubmit
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(translate)('login.login.submit')), 1)
                            ]),
                            _: 1
                        }, 8, ["disabled", "loading"])
                    ])
                ]),
                _: 1
            }, 8, ["is-open"]));
        };
    }
});
